<div class="core-edit-max-width">

  <div class="flex-row-space-between">

    <h1>Benutzer bearbeiten</h1>

    <core-button-slight
      (click)="onDeleteGroup(group)"
      *ngIf="form"
      [disabled]="form.disabled"
      [type]="InputButtonIconType.DELETE">
    </core-button-slight>

  </div>

  <form *ngIf="group && form" [formGroup]="form">

    <core-input-text
      formControlName="name"
      id="name"
      label="Name">
    </core-input-text>

    <core-input-text
      formControlName="description"
      id="description"
      label="Beschreibung">
    </core-input-text>

    <core-input-multiselect
      [options]="allPermissions"
      formControlName="permissions"
      id="permissions"
      label="Berechtigungen">
    </core-input-multiselect>

    <core-button-submit
      (click)="submitChanges()"
      [disabled]="form.invalid || form.disabled"
      id="button_submit">
    </core-button-submit>

  </form>

</div>
